import { PATH } from 'config'

const isContact2Path = () => {
  if (typeof window === "undefined") return

  const pathname = window.location.pathname
  return pathname.endsWith(PATH.CONTACT_2)
}

export default isContact2Path